import {
  CrafthuntBauGPTChat,
  initBauGPTEnvironment,
} from "@molteo-engineering-team/molteo-web-gpt-chat";
import { useWindowSize } from "@react-hookz/web";
import { ENV, isProd } from "constants/env";
import { useAuth } from "features/auth/context/AuthContext";
import { useHasHydrated } from "hooks/useHasHydrated";
import Router, { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { removeEmpty } from "utils/helpers";
import { convertLocaleForBackend } from "utils/language.helper";

type BauGPTProps = {
  locale: string;
};

export type TranslationDef = Record<string, string>;

export enum EFromJourney {
  DEFAULT = "default",
  BAUGPT = "baugpt",
}

export const getSharedTranslations = async (language: string): Promise<TranslationDef> => {
  return {
    ...(await import(`translations/shared/${language}.json`)).default,
  };
};

const BauGPT = ({ locale }: BauGPTProps) => {
  const hasHydrated = useHasHydrated();
  const router = useRouter();
  const size = useWindowSize();
  const height = size?.height;
  const lang = router.locale
  const [translations, setTranslations] = useState<TranslationDef>()
  initBauGPTEnvironment(ENV.BAUGPT_KEY, !false);
  
  const getTranslations = async () => {
    const t = await getSharedTranslations(lang)
    setTranslations(t)
  }
  
  useEffect(() => {
    getTranslations();
  }, [lang]);

  const handleOnSignup = () => {
    Router.push({
      pathname: 'https://app.molteo.de/signup',
      query: removeEmpty({
        ...router.query,
        fromJourney: EFromJourney.BAUGPT,
        slug: null,
      }),
    });
  };
  
  if (!hasHydrated ) {
    return null;
  }




  return (
    <div
      className="bg-white"
      style={{
        height: height - 200,
      }}
    >
      <div className="relative mx-auto max-w-7xl h-full md:px-4">
        <CrafthuntBauGPTChat
          jwt={''}
          translations={translations}
          lang={convertLocaleForBackend(locale)}
          onSignup={handleOnSignup}
        />
      </div>
    </div>
  );
};

export default BauGPT;
